import { useEffect, useState } from "react";
import { makeThumbnail } from "@/utils/image";

export function useFilePreview(file: File | null): string | null {
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return;
    }
    let active = true;
    setPreview(null);
    void makeThumbnail(file).then((url) => {
      if (active) setPreview(url);
    });
    return () => {
      active = false;
    };
  }, [file]);

  return preview;
}
